module.exports = __webpack_public_path__ + "img/GLD-alt.98981c5c.svg";